import { APIS } from "./api_factory";
import axios from 'axios';
import { POST_HEADER } from "./CustomApiHeader";

const TENANT_HEADER = {
    headers:{
        'X-Tenant-ID':"cf"
    }
}


const ParsedData=()=>{
    const SessionData = window.sessionStorage.getItem("AdminLogin")
    console.log("SessionData,SessionData",SessionData)
    const ParsedData = JSON.parse(SessionData)
    return ParsedData.email
}


export const EmployeeLogin = (email,password,callBack,error)=>{
    axios.get(APIS.EMPLOYEE_LOGIN + email + "&password=" + password)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}

export const getAMUCrifReport = (data,callBack,error)=>{
    const headerConfig = {
        headers:POST_HEADER,
    };
    
    axios.post(APIS.GET_AMU_CRIF_REPORT + ParsedData(), data ,headerConfig)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}

export const SendAMUOTP = (mobileNumber,callBack,error)=>{
    axios.get(APIS.SEND_AMU_OTP_BY_MOBILE_NUMBER + mobileNumber)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}
export const VerifyAMUOTP = (mobileNumber,otp,callBack,error)=>{
    axios.get(APIS.VERIFY_AMU_OTP_BY_MOBILE_NUMBER + mobileNumber + "&otp=" + otp)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}

export const getAmuAnalysis = (data,callBack,error)=>{
    const headerConfig = {
        headers:POST_HEADER,
    };
    axios.post(APIS.GET_AMU_ANALYSIS ,data,headerConfig)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}

export const getUserDataForScoreAnalysis = (userId,callBack,error)=>{
    axios.get(APIS.GET_USER_DATA_FOR_SCORE_ANALYSIS + userId)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}

export const regenerateAMUCrif = (userId, loanId, callBack) => {
    fetch(APIS.GET_CRIF_DATA + userId + '&loanId=' + loanId + '&regenerate=1')
    .then(res => res.text())
    .then(data => callBack(data))
    .catch(err => {
        console.error(err);
        callBack(null);
    });
}

export const isCrifGeneratedApi = (userId, loanId, callBack) => {
    fetch(APIS.IS_CRIF_GENERATED + userId + '&loanId=' + loanId,TENANT_HEADER)
    .then(res => res.json())
    .then(data => callBack(data))
    .catch(err => {
        console.error(err);
        callBack(null);
    });
}

export const getCrifSimilarityWithUserInfoApi = (userId, loanId, callBack) => {
    fetch(APIS.GET_CRIF_SIMILARITY + userId + '&loanId=' + loanId,TENANT_HEADER)
    .then(res => res.json())
    .then(data => callBack(data))
    .catch(err => {
        console.error(err);
        callBack(null);
    });
}

export const getCrifAnalysisV2Api = (userId, loanId, callBack) => {
    fetch(APIS.GET_CRIF_ANALYSIS_V2 + userId + '&loanId=' + loanId,TENANT_HEADER)
    .then(res => res.json())
    .then(data => callBack(data))
    .catch(err => {
        console.error(err);
        callBack(null);
    });
}

export const getCrifDataV2Api = (userId, loanId, regenerateParam, empId, callBack) => {
    fetch(APIS.GET_CRIF_DATA_V2 + userId + '&regenerateParam=' + regenerateParam + '&loanId=' + loanId + '&empId=' + empId,TENANT_HEADER)
    .then(res => res.text())
    .then(data => callBack(data))
    .catch(err => {
        console.error(err);
        callBack(null);
    });
}

export const getDetailsFromAppId = (appId, callBack, error) => {
    axios.get(APIS.GET_DETAILS_FROM_APP_ID + appId,TENANT_HEADER)
    .then(res => {
        callBack(res.data);
    })
    .catch(e => {
        console.log(e);
        callBack(e.response?.data);
    });
}